import React from "react";
import { FaExclamationTriangle } from "react-icons/fa";
import "./ui.css";

export function ErrorState({ title = "Something went wrong", message, action }) {
  return (
    <div className="ui-state">
      <div className="ui-state-icon ui-state-icon-danger"><FaExclamationTriangle /></div>
      <h5>{title}</h5>
      {message && <p>{message}</p>}
      {action}
    </div>
  );
}

export default ErrorState;
